import { Hero } from './Hero';
import { SignalNetwork } from './SignalNetwork';
import { FeatureGrid } from './FeatureGrid';
import { PricingSection } from './PricingSection';
import { FaqSection } from './FaqSection';
import { FinalCta } from './FinalCta';
import type { ReactNode } from 'react';

/**
 * Landing — the single public landing composition (DEC-051).
 *
 * One token-driven component tree serves both themes: light and dark are
 * handled entirely by the CSS-variable system on `[data-theme]` (no separate
 * per-theme components). Sequence: Hero → Signal Network → Feature Grid →
 * Pricing → FAQ → Final CTA.
 */
export function Landing(): ReactNode {
  return (
    <main id="main-content" tabIndex={-1}>
      <Hero />
      <SignalNetwork />
      <FeatureGrid />
      <PricingSection />
      <FaqSection count={6} />
      <FinalCta />
    </main>
  );
}

export default Landing;
